import { TenantSettingsIntegrationsTrackSolidDto } from './tenant-settings-integrations-track-solid.dto';

export class TenantSettingsGpsTrackersDto {
  isEnabled?: boolean | null;
  trackSolid?: TenantSettingsIntegrationsTrackSolidDto | null;
}
